<div class="alumni-page">
  <app-header-style-seven></app-header-style-seven>

  <div class="custom-container">
    <section class="alumni-hero">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker">Public Information</span>
          <h1>{{ pageTitle }}</h1>
          <p>{{ pageSubtitle }}</p>
        </div>

        <div class="hero-stats">
          <div class="stat-card" *ngFor="let stat of heroStats">
            <span class="stat-label">{{ stat.label }}</span>
            <strong>{{ stat.value }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="notice-bar" aria-label="Admission update">
      <div class="notice-label">Admissions Update</div>
      <div class="notice-track">
        <span>{{ admissionNotice }}</span>
      </div>
    </section>

    <section class="alumni-shell">
      <aside class="alumni-sidebar">
        <div class="sidebar-card">
          <span class="sidebar-kicker">RTI Menu</span>
          <h2>FMCET RTI Information</h2>

          <div class="tab-list">
            <button
              *ngFor="let tab of tabs"
              type="button"
              class="tab-btn"
              [class.active]="selectedTab === tab.id"
              (click)="selectTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </aside>

      <main class="alumni-main">
        <section class="content-head-card">
          <span class="content-tag">RTI Information</span>
          <h2>{{ activeTabLabel }}</h2>
          <p>
            Fatima Michael College of Engineering &amp; Technology, Madurai.
          </p>
        </section>

        <ng-container [ngSwitch]="selectedTab">
     <ng-container *ngSwitchCase="'tab1'">
  <section class="content-card">
    <div class="section-head">
      <h3>RTI Act</h3>
      <p>
        Right to Information Act details and Public Information Officer information.
      </p>
    </div>

    <div class="info-grid">
      <article class="info-card emphasis-card">
        <div class="section-copy">
          <p *ngFor="let paragraph of rtiParagraphs">
            {{ paragraph }}
          </p>

          <ul class="feature-list">
            <li><strong>Public Information Officer (PIO):</strong></li>
            <li><strong>Name:</strong> {{ pioName }}</li>
            <li><strong>Email:</strong> {{ pioEmail }}</li>
            <li><strong>Phone No:</strong> {{ pioPhone }}</li>
          </ul>
        </div>
      </article>

      <article class="info-card emphasis-card">
        <div class="document-image-card">
          <img src="assets/img/pdf/RTI.jpg" alt="RTI Act Document" />
        </div>
      </article>
    </div>
  </section>
</ng-container>
        </ng-container>
      </main>
    </section>

    <section class="bottom-cta">
      <article class="cta-card contact-card">
        <span class="cta-kicker">PIO Contact</span>
        <h3>Public Information Officer</h3>
        <p>
          <strong>Name:</strong> {{ pioName }}<br />
          <strong>Email:</strong> principal&#64;fmcet.ac.in<br />
          <strong>Phone:</strong> {{ pioPhone }}
        </p>
      </article>

      <article class="cta-card action-card">
        <span class="cta-kicker">Transparency</span>
        <h3>RTI &amp; Public Accountability</h3>
        <p>
          The Right to Information Act strengthens transparency, accountability,
          and citizen access to information in public authorities.
        </p>
      </article>
    </section>
  </div>
</div>